export enum ServiceUnavailable {
  AGE_RESTRICTION = 'age-restriction'
}
